webpackJsonp([1],{

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WorkDays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);






var uuidV4 = __webpack_require__(229);
var moment = __webpack_require__(0);
var _ = __webpack_require__(224);
var SETTINGS = 'settings';
var WORK_DAYS_ITEMS = 'workdayItems';

var WorkDays = function () {
  function WorkDays(storage) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WorkDays);

    this.storage = storage;
    if (!this.storage.get(SETTINGS)) {
      this.storage.set(SETTINGS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
        hourlyIncome: 8.84,
        currentFilter: moment().format('MMMM YYYY')
      }));
    }
    if (!this.storage.get(WORK_DAYS_ITEMS)) {
      this.storage.set(WORK_DAYS_ITEMS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()([]));
    }
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WorkDays, [{
    key: 'getAll',
    value: function getAll(filter) {
      if (!filter) {
        return JSON.parse(this.storage.get(WORK_DAYS_ITEMS));
      }
      var currentFilter = this.getSettings().currentFilter;
      var items = JSON.parse(this.storage.get(WORK_DAYS_ITEMS)).filter(function (s) {
        return moment(s.start).format('MMMM YYYY') === currentFilter;
      });
      return _.sortBy(items, 'start');
    }
  }, {
    key: 'getAvailableFilters',
    value: function getAvailableFilters() {
      var list = this.getAll();
      var filters = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(list.map(function (item) {
        return moment(item.start).format('MMMM YYYY');
      }))));
      return filters;
    }
  }, {
    key: 'getSettings',
    value: function getSettings() {
      return JSON.parse(this.storage.get(SETTINGS));
    }
  }, {
    key: 'setLocale',
    value: function setLocale(locale) {
      var settings = this.getSettings();
      settings.locale = locale;
      this.storage.set(SETTINGS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(settings));
    }
  }, {
    key: 'setHourlyIncome',
    value: function setHourlyIncome(hourlyIncome) {
      var settings = this.getSettings();
      settings.hourlyIncome = hourlyIncome;
      this.storage.set(SETTINGS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(settings));
    }
  }, {
    key: 'setCurrentFilter',
    value: function setCurrentFilter(filter) {
      var settings = this.getSettings();
      settings.currentFilter = filter;
      this.storage.set(SETTINGS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(settings));
    }
  }, {
    key: 'totalHours',
    value: function totalHours(data) {
      var total = 0;
      data.map(function (s) {
        total += moment.duration(s.end.diff(s.start));
      });
      return moment.duration(total).humanize;
    }
  }, {
    key: 'totalIncome',
    value: function totalIncome(data) {
      var total = 0;
      data.map(function (s) {
        total += s.income;
      });
      return total;
    }
  }, {
    key: 'getById',
    value: function getById(id) {
      var workdayItems = this.getAll();
      var itemIndex = workdayItems.findIndex(function (item) {
        return item.id === id;
      });
      if (itemIndex >= 0) {
        var item = workdayItems[itemIndex];
        item.itemIndex = itemIndex;
        return item;
      } else {
        return null;
      }
    }
  }, {
    key: 'setDateTime',
    value: function setDateTime(_date, _time) {
      var date = moment(_date);
      var time = moment(_time, 'HH:mm a');
      date.set({
        hour: time.get('hour'),
        minute: time.get('minute')
      });
      return date;
    }
  }, {
    key: 'save',
    value: function save(item) {
      var workdayItems = this.getAll();
      var settings = this.getSettings();
      var start = this.setDateTime(item.date, item.start);
      var end = this.setDateTime(item.date, item.end);
      if (end < start) {
        end.add(1, 'day');
      }
      var minutes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(moment.duration(end.diff(start)).asMinutes());
      var hours = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(minutes / 60);
      var lapse = hours + ':' + (minutes - hours * 60);
      var income = settings.hourlyIncome / 60 * minutes;
      var newItem = {
        id: item.id || uuidV4(),
        start: start,
        end: end,
        lapse: lapse,
        income: income
      };
      var itemIndex = workdayItems.findIndex(function (s) {
        return s.id === item.id;
      });
      if (itemIndex >= 0) {
        workdayItems[itemIndex] = newItem;
      } else {
        workdayItems.push(newItem);
      }
      this.storage.set(WORK_DAYS_ITEMS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(workdayItems));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      var workdayItems = this.getAll();
      var itemIndex = workdayItems.findIndex(function (item) {
        return item.id === id;
      });
      if (itemIndex >= 0) {
        workdayItems.splice(itemIndex, 1);
        this.storage.set(WORK_DAYS_ITEMS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(workdayItems));
      }
    }
  }]);

  return WorkDays;
}();

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(230);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  'en-US': {
    message: {
      locale: 'en-US',
      title: 'Workdays',
      income: 'Income',
      total: 'total',
      start: 'start',
      end: 'end',
      hours: 'hours',
      nodata: 'No data available',
      setincome: {
        title: 'Set Income',
        label: 'Ingreso'
      },
      list: {
        selectmonth: 'Active month'
      },
      buttons: {
        save: 'save',
        edit: 'edit',
        delete: 'delete'
      }
    }
  },
  'es-ES': {
    message: {
      locale: 'es-ES',
      title: 'Horas Trabajadas',
      income: 'Ingreso',
      total: 'Suma Total',
      start: 'desde',
      end: 'hasta',
      hours: 'horas',
      nodata: 'No existen datos',
      setincome: {
        title: 'Fijar Ingreso',
        label: 'Ingreso'
      },
      list: {
        selectmonth: 'Mes activo'
      },
      buttons: {
        save: 'Guardar',
        edit: 'Editar',
        delete: 'Eliminar'
      }
    }
  },
  'de-DE': {
    message: {
      locale: 'de-DE',
      title: 'Arbeitszeiten',
      income: 'Stundenlohn',
      total: 'Gesamt',
      start: 'von',
      end: 'bis',
      hours: 'Stunde',
      nodata: 'Keine verfügbare Daten',
      setincome: {
        title: 'Stundenlohn bearbeiten',
        label: 'Stundenlohn'
      },
      list: {
        selectmonth: 'Monat'
      },
      buttons: {
        save: 'Speichern',
        edit: 'Bearbeiten',
        delete: 'löschen'
      }
    }
  }
};

var numberFormats = {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD'
    }
  },
  'es-ES': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  },
  'de-DE': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  }
};

var dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    },
    time: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  'es-ES': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short'
    },
    time: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  'de-DE': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    },
    time: {
      hour: 'numeric',
      minute: 'numeric',
      hour24: true
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'es-ES', // set default locale
  messages: messages,
  numberFormats: numberFormats,
  dateTimeFormats: dateTimeFormats
}));

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Edit__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_List__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_View__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_View__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'List',
    component: __WEBPACK_IMPORTED_MODULE_3__components_List___default.a
  }, {
    path: '/view:id',
    name: 'View',
    component: __WEBPACK_IMPORTED_MODULE_4__components_View___default.a,
    props: true
  }, {
    path: '/new',
    name: 'Create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Edit___default.a
  }, {
    path: '/edit/:id',
    name: 'Edit',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Edit___default.a,
    props: true
  }]
}));

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_localstorage__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_localstorage__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      settings: { hourlyIncome: 0, currentFilter: '' },
      showDialog: false
    };
  },
  mounted: function mounted() {
    this.workdays = new __WEBPACK_IMPORTED_MODULE_0__api__["a" /* WorkDays */](this.$localStorage);
    this.settings = this.workdays.getSettings();
    if (this.settings.locale) {
      this._i18n.locale = this.settings.locale;
    }
  },

  methods: {
    loadList: function loadList() {
      this.$router.push('/');
    },
    saveIncome: function saveIncome() {
      this.showDialog = !this.showDialog;
      this.workdays.setHourlyIncome(this.settings.hourlyIncome);
    },
    cancel: function cancel() {
      this.settings = this.workdays.getSettings();
      this.showDialog = !this.showDialog;
    },
    setLocale: function setLocale(lang) {
      this._i18n.locale = lang;
      this.workdays.setLocale(lang);
    }
  }
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      workdays: null,
      dialogStart: false,
      dialogEnd: false,
      item: {
        date: new Date(),
        start: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('HH:mm a'),
        end: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('HH:mm a')
      }
    };
  },
  mounted: function mounted() {
    this.workdays = new __WEBPACK_IMPORTED_MODULE_0__api__["a" /* WorkDays */](this.$localStorage);
    var item = this.workdays.getById(this.id);
    if (item) {
      this.item = {
        id: this.id,
        date: item.date,
        start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.start).format('HH:mm a'),
        end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.end).format('HH:mm a')
      };
    }
  },

  methods: {
    saveItem: function saveItem() {
      this.workdays.save({
        id: this.id,
        date: this.item.date,
        start: this.item.start,
        end: this.item.end
      });
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selected: '',
      workdays: null,
      workdayItems: [],
      dialogStart: false,
      settings: { hourlyIncome: 0, currentFilter: '' },
      availableFilters: []
    };
  },
  mounted: function mounted() {
    this.workdays = new __WEBPACK_IMPORTED_MODULE_0__api__["a" /* WorkDays */](this.$localStorage);
    this.settings = this.workdays.getSettings();
    this.workdayItems = this.workdays.getAll(this.settings.currentFilter);
    this.availableFilters = this.workdays.getAvailableFilters();
    if (this.settings.locale) {
      this._i18n.locale = this.settings.locale;
    }
  },

  methods: {
    changeFilter: function changeFilter(e) {
      this.workdays.setCurrentFilter(e);
      this.workdayItems = this.workdays.getAll(e);
    },
    createItem: function createItem() {
      this.$router.push('new');
    },
    viewItem: function viewItem() {
      this.$router.push('view');
    }
  },
  computed: {
    totalHours: function totalHours() {
      return this.workdays ? this.workdays.totalHours(this.workdayItems) : 0;
    },
    totalIncome: function totalIncome() {
      return this.workdays ? this.workdays.totalIncome(this.workdayItems) : 0;
    },
    itemsCount: function itemsCount() {
      return this.workdays ? this.workdayItems.length : 0;
    }
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      item: { date: new Date(), start: new Date(), end: new Date(), income: 0 },
      workdays: null
    };
  },

  methods: {
    load: function load() {
      this.item = this.workdays.getById(this.id);
      if (!this.item) {
        this.$router.push('/');
      }
    },
    deleteItem: function deleteItem() {
      this.workdays.delete(this.item.id);
      this.$router.push('/');
    }
  },
  mounted: function mounted() {
    this.workdays = new __WEBPACK_IMPORTED_MODULE_0__api__["a" /* WorkDays */](this.$localStorage);
    this.load();
  }
});

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 46,
	"./af.js": 46,
	"./ar": 53,
	"./ar-dz": 47,
	"./ar-dz.js": 47,
	"./ar-kw": 48,
	"./ar-kw.js": 48,
	"./ar-ly": 49,
	"./ar-ly.js": 49,
	"./ar-ma": 50,
	"./ar-ma.js": 50,
	"./ar-sa": 51,
	"./ar-sa.js": 51,
	"./ar-tn": 52,
	"./ar-tn.js": 52,
	"./ar.js": 53,
	"./az": 54,
	"./az.js": 54,
	"./be": 55,
	"./be.js": 55,
	"./bg": 56,
	"./bg.js": 56,
	"./bn": 57,
	"./bn.js": 57,
	"./bo": 58,
	"./bo.js": 58,
	"./br": 59,
	"./br.js": 59,
	"./bs": 60,
	"./bs.js": 60,
	"./ca": 61,
	"./ca.js": 61,
	"./cs": 62,
	"./cs.js": 62,
	"./cv": 63,
	"./cv.js": 63,
	"./cy": 64,
	"./cy.js": 64,
	"./da": 65,
	"./da.js": 65,
	"./de": 68,
	"./de-at": 66,
	"./de-at.js": 66,
	"./de-ch": 67,
	"./de-ch.js": 67,
	"./de.js": 68,
	"./dv": 69,
	"./dv.js": 69,
	"./el": 70,
	"./el.js": 70,
	"./en-au": 71,
	"./en-au.js": 71,
	"./en-ca": 72,
	"./en-ca.js": 72,
	"./en-gb": 73,
	"./en-gb.js": 73,
	"./en-ie": 74,
	"./en-ie.js": 74,
	"./en-nz": 75,
	"./en-nz.js": 75,
	"./eo": 76,
	"./eo.js": 76,
	"./es": 78,
	"./es-do": 77,
	"./es-do.js": 77,
	"./es.js": 78,
	"./et": 79,
	"./et.js": 79,
	"./eu": 80,
	"./eu.js": 80,
	"./fa": 81,
	"./fa.js": 81,
	"./fi": 82,
	"./fi.js": 82,
	"./fo": 83,
	"./fo.js": 83,
	"./fr": 86,
	"./fr-ca": 84,
	"./fr-ca.js": 84,
	"./fr-ch": 85,
	"./fr-ch.js": 85,
	"./fr.js": 86,
	"./fy": 87,
	"./fy.js": 87,
	"./gd": 88,
	"./gd.js": 88,
	"./gl": 89,
	"./gl.js": 89,
	"./gom-latn": 90,
	"./gom-latn.js": 90,
	"./he": 91,
	"./he.js": 91,
	"./hi": 92,
	"./hi.js": 92,
	"./hr": 93,
	"./hr.js": 93,
	"./hu": 94,
	"./hu.js": 94,
	"./hy-am": 95,
	"./hy-am.js": 95,
	"./id": 96,
	"./id.js": 96,
	"./is": 97,
	"./is.js": 97,
	"./it": 98,
	"./it.js": 98,
	"./ja": 99,
	"./ja.js": 99,
	"./jv": 100,
	"./jv.js": 100,
	"./ka": 101,
	"./ka.js": 101,
	"./kk": 102,
	"./kk.js": 102,
	"./km": 103,
	"./km.js": 103,
	"./kn": 104,
	"./kn.js": 104,
	"./ko": 105,
	"./ko.js": 105,
	"./ky": 106,
	"./ky.js": 106,
	"./lb": 107,
	"./lb.js": 107,
	"./lo": 108,
	"./lo.js": 108,
	"./lt": 109,
	"./lt.js": 109,
	"./lv": 110,
	"./lv.js": 110,
	"./me": 111,
	"./me.js": 111,
	"./mi": 112,
	"./mi.js": 112,
	"./mk": 113,
	"./mk.js": 113,
	"./ml": 114,
	"./ml.js": 114,
	"./mr": 115,
	"./mr.js": 115,
	"./ms": 117,
	"./ms-my": 116,
	"./ms-my.js": 116,
	"./ms.js": 117,
	"./my": 118,
	"./my.js": 118,
	"./nb": 119,
	"./nb.js": 119,
	"./ne": 120,
	"./ne.js": 120,
	"./nl": 122,
	"./nl-be": 121,
	"./nl-be.js": 121,
	"./nl.js": 122,
	"./nn": 123,
	"./nn.js": 123,
	"./pa-in": 124,
	"./pa-in.js": 124,
	"./pl": 125,
	"./pl.js": 125,
	"./pt": 127,
	"./pt-br": 126,
	"./pt-br.js": 126,
	"./pt.js": 127,
	"./ro": 128,
	"./ro.js": 128,
	"./ru": 129,
	"./ru.js": 129,
	"./sd": 130,
	"./sd.js": 130,
	"./se": 131,
	"./se.js": 131,
	"./si": 132,
	"./si.js": 132,
	"./sk": 133,
	"./sk.js": 133,
	"./sl": 134,
	"./sl.js": 134,
	"./sq": 135,
	"./sq.js": 135,
	"./sr": 137,
	"./sr-cyrl": 136,
	"./sr-cyrl.js": 136,
	"./sr.js": 137,
	"./ss": 138,
	"./ss.js": 138,
	"./sv": 139,
	"./sv.js": 139,
	"./sw": 140,
	"./sw.js": 140,
	"./ta": 141,
	"./ta.js": 141,
	"./te": 142,
	"./te.js": 142,
	"./tet": 143,
	"./tet.js": 143,
	"./th": 144,
	"./th.js": 144,
	"./tl-ph": 145,
	"./tl-ph.js": 145,
	"./tlh": 146,
	"./tlh.js": 146,
	"./tr": 147,
	"./tr.js": 147,
	"./tzl": 148,
	"./tzl.js": 148,
	"./tzm": 150,
	"./tzm-latn": 149,
	"./tzm-latn.js": 149,
	"./tzm.js": 150,
	"./uk": 151,
	"./uk.js": 151,
	"./ur": 152,
	"./ur.js": 152,
	"./uz": 154,
	"./uz-latn": 153,
	"./uz-latn.js": 153,
	"./uz.js": 154,
	"./vi": 155,
	"./vi.js": 155,
	"./x-pseudo": 156,
	"./x-pseudo.js": 156,
	"./yo": 157,
	"./yo.js": 157,
	"./zh-cn": 158,
	"./zh-cn.js": 158,
	"./zh-hk": 159,
	"./zh-hk.js": 159,
	"./zh-tw": 160,
	"./zh-tw.js": 160
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(235),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "Work",
      "toolbar": "",
      "fixed-footer": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "indigo",
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "{cursor": "hand}"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.loadList()
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.loadList()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("home")])], 1), _vm._v("\n      " + _vm._s(_vm.$t("message.title")) + "                \n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary body-2",
    attrs: {
      "outline": "",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDialog = !_vm.showDialog
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("message.income")) + ": " + _vm._s(_vm.$n(_vm.settings.hourlyIncome, 'currency')) + "\n    ")])], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "indigo",
    attrs: {
      "fixed": "",
      "absolute": "",
      "text-xs-center": ""
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Made with ♥ in Berlin")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.setLocale('es-ES')
      }
    }
  }, [_c('img', {
    staticClass: "flag flag-es"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.setLocale('en-US')
      }
    }
  }, [_c('img', {
    staticClass: "flag flag-us"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.setLocale('de-DE')
      }
    }
  }, [_c('img', {
    staticClass: "flag flag-de"
  })])], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("message.setincome.title")) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "label": _vm.$t('message.setincome.label'),
      "type": "number"
    },
    model: {
      value: (_vm.settings.hourlyIncome),
      callback: function($$v) {
        _vm.settings.hourlyIncome = $$v
      },
      expression: "settings.hourlyIncome"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": ""
    },
    on: {
      "click": function($event) {
        _vm.saveIncome()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("save")]), _vm._v("\n          " + _vm._s(_vm.$t("message.buttons.save")) + "\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$d(_vm.item.date, 'long')))])]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v(_vm._s(_vm.$t("message.start")) + ": " + _vm._s(_vm._f("moment")(_vm.item.start, "HH:mm a")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.end")) + ": " + _vm._s(_vm._f("moment")(_vm.item.end, "HH:mm a")))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.hours")) + ": " + _vm._s(_vm.item.lapse))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.income")) + ": " + _vm._s(_vm.$n(_vm.item.income, 'currency')))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": "",
      "to": {
        name: 'Edit',
        params: {
          id: this.id
        }
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("edit")]), _vm._v("\n            " + _vm._s(_vm.$t("message.buttons.edit")) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteItem()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("delete")]), _vm._v("\n            " + _vm._s(_vm.$t("message.buttons.delete")) + "\n        ")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "mt-4": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "blue accent-2"
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('message.list.selectmonth'),
      "no-data-text": _vm.$t('message.nodata'),
      "items": _vm.availableFilters,
      "dark": "",
      "prepend-icon": "date_range"
    },
    on: {
      "change": _vm.changeFilter
    },
    model: {
      value: (_vm.settings.currentFilter),
      callback: function($$v) {
        _vm.settings.currentFilter = $$v
      },
      expression: "settings.currentFilter"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "green",
    attrs: {
      "fab": "",
      "small": "",
      "top": "",
      "right": "",
      "absolute": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.createItem($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.workdayItems), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "avatar": "",
        "to": {
          name: 'View',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-chip', {
      staticClass: "green white--text"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.start, "DD")))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(_vm._f("moment")(item.start, "HH:mm a")) + " - " + _vm._s(_vm._f("moment")(item.end, "HH:mm a")))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(" (" + _vm._s(item.lapse) + ")")]), _vm._v("\n                  " + _vm._s(_vm.$n(item.income, 'currency')) + "\n               ")])], 1)], 1)]
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "blue accent-2 white--text"
  }, [_c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "white--text text-xs-right body-2"
  }, [_vm._v("\n           " + _vm._s(_vm.$t('message.total')) + ": " + _vm._s(_vm.$n(_vm.totalIncome, 'currency')) + "            \n         ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-date-picker', {
    attrs: {
      "locale": _vm.$t('message.locale')
    },
    model: {
      value: (_vm.item.date),
      callback: function($$v) {
        _vm.item.date = $$v
      },
      expression: "item.date"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogStart = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.start")) + ": " + _vm._s(_vm._f("moment")(_vm.item.start, "HH:mm a")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogEnd = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.end")) + ": " + _vm._s(_vm._f("moment")(_vm.item.end, "HH:mm a")))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "button": "",
      "right": "",
      "success": "",
      "absolute": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.saveItem()
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialogStart),
      callback: function($$v) {
        _vm.dialogStart = $$v
      },
      expression: "dialogStart"
    }
  }, [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-time-picker', {
    model: {
      value: (_vm.item.start),
      callback: function($$v) {
        _vm.item.start = $$v
      },
      expression: "item.start"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "primary text-xs-right",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogStart = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v("\n        OK\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialogEnd),
      callback: function($$v) {
        _vm.dialogEnd = $$v
      },
      expression: "dialogEnd"
    }
  }, [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-time-picker', {
    model: {
      value: (_vm.item.end),
      callback: function($$v) {
        _vm.item.end = $$v
      },
      expression: "item.end"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "primary text-xs-right",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogEnd = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v("\n        OK\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

},[168]);


// WEBPACK FOOTER //
// static/js/app.89dac99233150e93b424.js